import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GlobalService } from 'src/app/_services/global.service';
import { DataService } from 'src/app/dashboard/_services/data.service';
import { BusStudentsService } from '../../_services/bus-students.service';
import {EnrollError} from '../enroll-error-interface'
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';
import * as XLSX from 'xlsx';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-enroll-errors',
  templateUrl: './enroll-errors.component.html',
  styleUrls: ['./enroll-errors.component.scss']
})
export class EnrollErrorsComponent {
  enrollErrors:EnrollError[] = [];
  destroy$ = new Subject<void>(); 
  currLang;
  baseUrl = environment.img_url;

  constructor(
    private dataService: DataService,
    private globalService: GlobalService,
    private translate: TranslateService,
    private busesStudentsService: BusStudentsService,
    private _router:Router,
    private location: Location) {
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.globalService.getLang().pipe(takeUntil(this.destroy$)).subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    this.busesStudentsService.getEnrollErrors().pipe(takeUntil(this.destroy$)).subscribe((res:EnrollError[])=>{
      this.enrollErrors= res;
    });

    // Override browser back button behavior by modifying history
    this.location.replaceState('/buses/students');
    this.location.go('/buses/enroll-errors');
  }

  exportToExcel() {
    // Transform the data to exclude `image_path` and include error messages in the correct language
    const data = this.enrollErrors.map(student => {
      return {
        id: student.id,
        name: student.name,
        national_id: student.national_id,
        error_message: student.error_messages
          .map(msg => this.currLang === 'en' ? msg.en : msg.ar)
          .join(', ') // Join all messages with a comma
      };
    });

    // Create a worksheet from the transformed data
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Create a workbook and add the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Students');

    // Export the workbook to a file
    XLSX.writeFile(workbook, 'Students.xlsx');
  }

  back() {
    this._router.navigateByUrl('/buses/students');
  }
  
}
